export enum AuthMode {
  None = 'None',
  SecondSignIn = 'SecondSignIn', // Determinate requiring to admit all app permissions needs for 'Sign In As Admin' or Creating new Domain
  AnotherAccount = 'AnotherAccount', // Determinate auth for another account, needs for 'restore to...'
  ProviderSignIn = 'ProviderSignIn',
  Onboarding = 'Onboarding',
  AlternativeAccount = 'AlternativeAccount'
}
